import { useState, useEffect, useCallback } from 'react'
import { checkStorageOptions } from '../../Utils/Window/windowHelpers'
import type { StorageOptionsStatus } from '../../Constants'

type StorageReadyState = {
  isReady: boolean
  isChecking: boolean
  error: string | null
  storageStatuses: StorageOptionsStatus
}

export const useStorageReady = (): StorageReadyState => {
  const [state, setState] = useState<StorageReadyState>({
    isReady: false,
    isChecking: true,
    error: null,
    storageStatuses: {
      indexedDB: false,
      local: false,
      session: false,
      cookies: false,
    },
  })

  const checkStorageReadiness = useCallback(async (): Promise<void> => {
    setState((prev) => ({ ...prev, isChecking: true, error: null }))

    try {
      // Check basic availability
      const basicStatuses = checkStorageOptions()
      const hasWorkingStorage =
        basicStatuses.indexedDB || basicStatuses.local || basicStatuses.session
      setState({
        isReady: hasWorkingStorage,
        isChecking: false,
        error: hasWorkingStorage ? null : 'All storage methods failed verification',
        storageStatuses: basicStatuses,
      })
    } catch (error) {
      setState({
        isReady: false,
        isChecking: false,
        error:
          error instanceof Error
            ? error.message
            : 'Unknown storage initialization error',
        storageStatuses: {
          indexedDB: false,
          local: false,
          session: false,
          cookies: false,
        },
      })
    }
  }, [])

  useEffect(() => {
    checkStorageReadiness()
  }, [checkStorageReadiness])

  return state
}
